// import VueCookies from 'vue-cookies';
/* ------------ Basic Line ------------ */
export function isAndroid() {
    return /(Android)/i.test(navigator.userAgent);
}

export function isIOS() {
    return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
}

export function setupWebViewJavascriptBridge(callback) {

    if (window.WebViewJavascriptBridge) {
        return callback(window.WebViewJavascriptBridge);
    }

    if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback);
    }

    window.WVJBCallbacks = [callback];

    var WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';

    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function() {
        document.documentElement.removeChild(WVJBIframe);
    }, 0);
}

/* ------------ API Line ------------ */
// 关闭弹窗
export function closeWindow() {
    if (isAndroid()) {
        window.demo.closePop();
    } else if (isIOS()) {
        setupWebViewJavascriptBridge(function(bridge) {
            bridge.callHandler(
                'closeFlash',
                {
                    message: '',
                },
                function responseCallback() {},
            );
        });
    }
}

//关闭页面
export function autoCloseWindow() {
    if (isAndroid()) {
        window.demo.finishActivity('');
    } else if (isIOS()) {
        setupWebViewJavascriptBridge(function(bridge) {
            bridge.callHandler(
                'closeFlash',
                {
                    message: '',
                },
                function responseCallback() {},
            );
        });
    }
}

// API: close H5-window and do something
export function closeWindow4Active(mark) {
    if (isAndroid()) {
        window.demo.finishActivity(mark);
    }
}

// API: set title-bar color
export function setTitleBarColor(backColor, fontColor) {
    if (isAndroid()) {
        window.demo.setTitleBarColor(backColor, fontColor);
    } else if (isIOS()) {
        setupWebViewJavascriptBridge(function(bridge) {
            bridge.callHandler(
                'setTitleBarColor',
                {
                    backColor: backColor,
                    fontColor: fontColor,
                },
                function responseCallback() {},
            );
        });
    }
}


// API: show right-top menu
export function showRightTop(json, title) {
    if (isAndroid()) {
        window.demo.showRightTop(json, title);
    } else if (isIOS()) {
        setupWebViewJavascriptBridge(function(bridge) {
            bridge.callHandler(
                'showRightTop',
                {
                    json: eval(json),
                    title: title,
                },
                function responseCallback() {},
            );
        });
    }
}


export function hideRightTop() {
    if (isAndroid()) {
        window.demo.hideRightTop()
    } else if (isIOS()) {
        setupWebViewJavascriptBridge(function(bridge) {
            bridge.callHandler(
                'hideRightTop',
                {},
                function responseCallback() {
                },
            )
        })
    }
}


// API: call onlinePay to show payPwd window
export function onlinePay(type, amount, extra) {
    if (isAndroid()) {
        window.demo.onlinePay(type, amount, extra);
    } else if (isIOS()) {
        setupWebViewJavascriptBridge(function(bridge) {
            bridge.callHandler(
                'onlinePay',
                {
                    type: type,
                    amount: amount,
                    extra: extra,
                },
                function responseCallback() {},
            );
        });
    }
}

// API: upload image from H5, call native to handle
export function uploadImage(maxWidth, maxHeight, quality, imgRepr) {
    quality = 80;
    if (isAndroid()) {
        window.demo.uploadImage(maxWidth, maxHeight, quality, imgRepr);
    } else if (isIOS()) {
        setupWebViewJavascriptBridge(function(bridge) {
            bridge.callHandler(
                'uploadImage',
                {
                    maxWidth: maxWidth,
                    maxHeight: maxHeight,
                    quality: quality,
                    imgRepr: imgRepr,
                },
                function responseCallback() {},
            );

            bridge.registerHandler('uploadImageCallback', function(
                data
            ){
                data = eval('(' + data + ')');
                window.uploadImageCallback(data.path, data.signedPath);
            });
        });
    }
}

// Notify: upload image success callback
// export function uploadImageCallback(path, signedPath) {
//     responseImgPath(path, signedPath);
// }

// API: set h5 Title
export function setWebTitle(title) {
    if (isAndroid()) {
        window.demo.setWebTitle(title);
    } else if (isIOS()) {
        setupWebViewJavascriptBridge(function(bridge) {
            bridge.callHandler(
                'setWebTitle',
                {
                    title: title,
                },
                function responseCallback() {},
            );
        });
    }
}

// API: hint user jump to login
export function logout(msg) {
    if (isAndroid()) {
        window.demo.logout(msg);
    } else if (isIOS()) {
        setupWebViewJavascriptBridge(function(bridge) {
            bridge.callHandler(
                'logout',
                {
                    msg: msg,
                },
                function responseCallback() {},
            );
        });
    }
}

export function androidGoToAppViewByRouter(routerUrl) {
    window.demo.toOtherActivity(routerUrl);
}

/**
 * 调用原生二维码扫码功能 需要版本号判断
 */
export function scanQRCode(title) {
    let externalTitle=encodeURIComponent(title);  //标题转码
    let qrCodeUrl = "https://app.robooot.com/web/ScanWebQRCodeActivity?externalTitle="+externalTitle;
    if (isAndroid()) {
        androidGoToAppViewByRouter(qrCodeUrl);
    } else if (isIOS()) {
        setupWebViewJavascriptBridge(function (bridge) {

            bridge.callHandler('goToVC', {
                    'routerUrl': qrCodeUrl,
                },
                function responseCallback() {}
            );

            bridge.registerHandler('getScanningQRCode', function(data) {
                data = eval('(' + data + ')');
                window.getScanningQRCode(data.qrCode)
            });
        });
    }
}

export function showGoBackBtn(array) {
    if (isAndroid()) {
        window.demo.showGoBackBtn(JSON.stringify(array));
    } else if (isIOS()) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('showGoBackBtn',array,
                function responseCallback() {
                });
            bridge.registerHandler('toAccess', function (data) {
                window.toAccess(data)
            });
            bridge.registerHandler('toDeal', function (data) {
                window.toDeal(data)
            });
        });
    }
}

export function goTo(routerUrl,className, classParams,name) {
    goToAppViewByRouter(routerUrl,'faceid', name, '', className, classParams);
}

export function goToAppViewByRouter(routerUrl,androidKey, androidName,androidType,iOSClassName,iOSClassParams) {
    if (isAndroid()) {
        // window.demo.toOtherActivity(androidKey, androidName, androidType);
        androidGoToAppViewByRouter(routerUrl);
    } else if (isIOS()) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('goToVC', {
                    'className': iOSClassName,
                    'classParams': JSON.stringify(iOSClassParams),
                    'routerUrl': routerUrl,
                },
                function responseCallback() {
                });
        });
    }
}

export function showNavigationRightMoreButton(isShow,title) {
    if (isAndroid()) {
        window.demo.showNavigationRightMoreButton(isShow,title);
    } else if (isIOS()) {
        setupWebViewJavascriptBridge(function(bridge) {
            bridge.callHandler(
                'showNavigationRightMoreButton',
                {
                    isShow:isShow,
                    title:title,
                },
                function responseCallback() {},
            );
            bridge.registerHandler('navigationRightMoreButtonClicked', function () {
                window.navigationRightMoreButtonClicked()
            });
        });
    }
}

//获取版本号
export function getAppVersion(qwe) {
    if (isAndroid()) {
        let result = window.demo.getAppVersion();
        qwe(result)
    } else if (isIOS()) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('getAppVersion', {
                },
                function responseCallback(responseData) {
                    qwe(responseData)
                });
        });
    }
}


export function goToClose(routerUrl,className, classParams,name) {
    goToAppViewByRouterClose(routerUrl,'faceid', name, '', className, classParams);
}

export function goToAppViewByRouterClose(routerUrl,androidKey, androidName,androidType,iOSClassName,iOSClassParams) {
    if (isAndroid()) {
        // window.demo.toOtherActivity(androidKey, androidName, androidType);
        androidGoToAppViewByRouterClose(routerUrl);
    } else if (isIOS()) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('goToVC', {
                    'className': iOSClassName,
                    'classParams': JSON.stringify(iOSClassParams),
                    'routerUrl': routerUrl,
                },
                function responseCallback() {
                });
        });
        closeWindow();
    }
}

export function androidGoToAppViewByRouterClose(routerUrl) {
    window.demo.toOtherActivity(routerUrl);
    closeWindow();
}


/**
 * app内闪光
 */
export function blindFlash() {
    if (isAndroid()) {
        window.demo.flashInApp();
    } else if (isIOS()) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('flashInApp', {
                },
                function responseCallback() {
                }
            );

            bridge.registerHandler('flashResultBackFromApp', function(data) {
                window.flashResultBackFromApp(data)
            });
        });
    }

}


/**
 * app内人脸识别
 */
export function faceIdentifyInApp(authMode, outNumber, notifyUrl) {
    if (isAndroid()) {
         window.demo.startFaceIdentifyInApp(authMode, outNumber, notifyUrl);
    } else if (isIOS()) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('startFaceIdentifyInApp', {
                    'authMode':authMode,
                    'outNumber':outNumber,
                    'notifyUrl':notifyUrl
                },
                function responseCallback() {
                }
            );

            bridge.registerHandler('faceIdentifyResultBackFromApp', function(data) {
                window.faceIdentifyResultBackFromApp(data)
            });
        });
    }

}


/** 软键盘弹出压缩布局*/
export function inputCompress() {
    if (isAndroid()) {
        window.demo.setSoftInputAdjustResize();
    }
}

/** 解除软键盘弹出压缩布局*/
export function inputCover() {
    if (isAndroid()) {
        window.demo.setSoftInputAdjustPan();
    }
}



/**
 * 
 * 
 * @param {*} phone 手机号
 * 
 * 改造 返回Promise
 * 
 * app返回结果 
 * { 
 *  result: 0,     // -1 请求失败
 *  message: '获取成功'
 * }
 */
 export function sendSMS(phone) {

    if (!window.sySendSMSPromise || window.sySendSMSPromise.status !== 'pending') {
        window.sySendSMSPromise = new Promise((resolve) => {
            if (isAndroid()) {
                window.sySendSMSCallback = resolve
                
                window.demo.sendSMS(phone);
            } 
            else if (isIOS()) {
                setupWebViewJavascriptBridge(function (bridge) {
                    bridge.callHandler('sendSMS', {
                        'phone': phone
                    },
                        function responseCallback() {
                            // 是否可以同步
                        }
                    );

                    bridge.registerHandler('sySendSMSCallback', function (data) {
                        resolve(data)
                    });
                });
            }

        })
    }

    return window.sySendSMSPromise;

}
